'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { Cookie } from 'lucide-react';
import { pathTo } from '@/lib/base-path';
import { acceptCookieConsent, hasCookieConsent } from '@/lib/cookie-consent';

/** Banner de consentimento de cookies (LGPD). Exibido até o usuário aceitar. */
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasCookieConsent());
  }, []);

  const aceitar = () => {
    acceptCookieConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Consentimento de cookies"
      className="fixed inset-x-0 bottom-0 z-[900] p-4 sm:p-6 pointer-events-none"
    >
      <div className="mx-auto max-w-4xl pointer-events-auto rounded-xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-2xl shadow-black/10 dark:shadow-black/40 p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex gap-3 min-w-0 flex-1">
            <div className="shrink-0 w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-950/40 flex items-center justify-center">
              <Cookie className="w-5 h-5 text-blue-600 dark:text-blue-400" aria-hidden />
            </div>
            <div className="min-w-0 text-sm text-gray-600 dark:text-slate-300 leading-relaxed">
              <p className="font-medium text-gray-800 dark:text-slate-100 mb-1">Este site utiliza cookies</p>
              <p>
                Usamos cookies e armazenamento local essenciais para manter sua sessão de acesso,
                preferências (como tema claro/escuro) e o funcionamento seguro do portal.
                Ao continuar, você concorda com esse uso conforme a LGPD.
                {' '}
                <Link
                  href={pathTo('/ajuda')}
                  className="text-blue-600 dark:text-blue-400 hover:underline font-medium whitespace-nowrap"
                >
                  Saiba mais
                </Link>
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={aceitar}
            className="shrink-0 w-full sm:w-auto px-5 py-2.5 btn-primary rounded-lg text-sm font-medium"
          >
            Aceitar cookies
          </button>
        </div>
      </div>
    </div>
  );
}
